module.exports = __webpack_public_path__ + "img/nr-logo.ad36204c.png";